// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/home/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/home/operations-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/home/home-slider-bg-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/home/home-slider-mobile-bg-1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  width: 100%;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  color: #445169;
  line-height: 120%;
  padding-top: 68px;
}
.home-page a {
  color: #445169;
  text-decoration: none;
}
.home-page .home-page-content {
  padding-left: 20px;
  padding-right: 20px;
}
.home-page .home-page-content .home-page-hero {
  width: 100%;
  min-height: 570px;
  background-color: #040e46;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  border-radius: 20px;
  margin-top: 22px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.home-page .home-page-content .home-page-hero .left-block {
  color: #fff;
  padding-top: 100px;
  padding-left: 100px;
}
.home-page .home-page-content .home-page-hero .left-block .home-page-hero-title {
  font-size: 46px;
  font-weight: 600;
  line-height: 120%;
}
.home-page .home-page-content .home-page-hero .left-block .home-page-hero-title .blue-part {
  color: #a5c7ff;
}
.home-page .home-page-content .home-page-hero .left-block .home-page-hero-subtitle {
  margin-top: 24px;
  font-size: 22px;
  font-weight: 400;
  color: #a5c7ff;
  line-height: 180%;
}
.home-page .home-page-content .home-page-hero .left-block .hero-request-demo-btn {
  margin-top: 60px;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid #dee1e7;
  border-radius: 8px;
  padding: 12px 24px 12px 24px;
  gap: 8px;
  display: flex;
  align-items: center;
  width: 200px;
  height: 46px;
  color: #448aff;
  font-weight: 600;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.home-page .home-page-content .home-page-hero .right-block {
  display: flex;
  align-items: end;
}
.home-page .home-page-content .home-page-hero .right-block img {
  height: 288px;
  width: auto;
  margin-right: 50px;
  margin-bottom: 50px;
}
.home-page .home-page-content .problem-solution {
  display: flex;
  height: 490px;
  padding-top: 50px;
  padding-left: 55px;
  min-height: 490px;
}
.home-page .home-page-content .problem-solution .paper-wrapper {
  width: 27%;
  padding-top: 40px;
}
.home-page .home-page-content .problem-solution .paper-wrapper img {
  width: 100%;
  height: auto;
}
.home-page .home-page-content .problem-solution .problem-solution-center-block {
  flex-grow: 1;
  text-align: center;
}
.home-page .home-page-content .problem-solution .problem-solution-center-block .problem-solution-arrow-wrapper {
  text-align: center;
}
.home-page .home-page-content .problem-solution .problem-solution-center-block .problem-solution-text {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  font-size: 24px;
  max-width: 360px;
  font-weight: 400;
  line-height: 180%;
  text-align: center;
}
.home-page .home-page-content .problem-solution .problem-solution-center-block .problem-solution-text .blue-part {
  color: #448aff;
}
.home-page .home-page-content .problem-solution .problem-solution-center-block .how-it-works-btn {
  margin-top: 36px;
  color: #448aff;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
  border: 2px solid #e7f0ff;
  padding: 12px 24px 12px 24px;
  background-color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  margin-right: auto;
}
.home-page .home-page-content .problem-solution .problem-solution-right-block {
  width: 28%;
}
.home-page .home-page-content .problem-solution .problem-solution-right-block img {
  width: 100%;
  height: auto;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.2196078431);
}
.home-page .home-page-content .staff-education {
  background-color: #f9fafb;
  width: 100%;
  border: 1px solid rgb(236, 238, 241);
  border-radius: 20px;
  padding: 80px 100px;
  display: flex;
  gap: 80px;
}
.home-page .home-page-content .staff-education .staff-education-left-block {
  max-width: 470px;
  min-width: 470px;
}
.home-page .home-page-content .staff-education .staff-education-left-block img {
  width: 100%;
  height: auto;
  max-height: 350px;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.2196078431);
}
.home-page .home-page-content .staff-education .staff-education-right-block {
  padding-top: 60px;
}
.home-page .home-page-content .staff-education .staff-education-right-block .staff-education-chip {
  background-color: #3571d6;
  padding: 4px 14px;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.2196078431);
  color: #fff;
  border-radius: 99px;
  font-size: 20px;
  font-weight: 500;
  display: inline;
}
.home-page .home-page-content .staff-education .staff-education-right-block .staff-education-title {
  margin-top: 36px;
  font-size: 40px;
  font-weight: 400;
  line-height: 120%;
}
.home-page .home-page-content .staff-education .staff-education-right-block .staff-education-subtitle {
  margin-top: 36px;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
}
.home-page .home-page-content .compliance-block {
  width: 100%;
  padding: 80px 100px;
  display: flex;
  gap: 80px;
  justify-content: space-between;
}
.home-page .home-page-content .compliance-block .compliance-right-block {
  max-width: 470px;
  min-width: 470px;
}
.home-page .home-page-content .compliance-block .compliance-right-block img {
  width: 100%;
  height: auto;
  max-height: 320px;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.2196078431);
}
.home-page .home-page-content .compliance-block .compliance-left-block {
  padding-top: 60px;
}
.home-page .home-page-content .compliance-block .compliance-left-block .compliance-chip {
  background-color: #3571d6;
  padding: 4px 14px;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.2196078431);
  color: #fff;
  border-radius: 99px;
  font-size: 20px;
  font-weight: 500;
  display: inline;
}
.home-page .home-page-content .compliance-block .compliance-left-block .compliance-title {
  margin-top: 36px;
  font-size: 40px;
  font-weight: 400;
  line-height: 120%;
}
.home-page .home-page-content .compliance-block .compliance-left-block .compliance-subtitle {
  margin-top: 36px;
  font-size: 20px;
  line-height: 180%;
  max-width: 480px;
}
.home-page .home-page-content .operations-block {
  background-color: #3571d6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 686px;
  padding: 60px;
  border-radius: 20px;
  background-size: cover;
}
.home-page .home-page-content .operations-block .operations-title {
  font-size: 40px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.home-page .home-page-content .operations-block .operation-items-wrapper {
  display: flex;
  gap: 48px;
  margin-top: 70px;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item {
  flex: 1 1;
  width: 100%;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item:nth-child(1) {
  padding-top: 100px;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item:nth-child(3) {
  padding-top: 100px;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item img {
  width: 100%;
  height: 240px;
  background-size: cover;
  border: 1px solid #fff;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  border-radius: 10px;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item .operation-item-text-wrapper {
  padding-left: 14px;
  padding-right: 14px;
  margin-top: 24px;
  color: #fff;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item .operation-item-text-wrapper .operation-item-title {
  font-size: 28px;
  line-height: 130%;
  font-weight: 600;
}
.home-page .home-page-content .operations-block .operation-items-wrapper .operation-item .operation-item-text-wrapper .operation-item-subtitle {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}
.home-page .easy-access {
  padding: 185px 80px;
  min-height: 520px;
  margin-top: 20px;
  border: 1px solid #98a2b3;
  border-radius: 20px;
  background-size: cover;
}
.home-page .easy-access.bg-0 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: right;
}
.home-page .easy-access .section-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 40px;
  text-align: center;
  color: #040e46;
}
.home-page .easy-access .easy-access-slider {
  position: relative;
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
}
.home-page .easy-access .easy-access-slider .slider-container {
  width: 100%;
  overflow: hidden;
  border-radius: 16px;
  background-color: #fff;
}
.home-page .easy-access .easy-access-slider .slide-content {
  padding: 38px 46px 46px 46px;
  text-align: left;
}
.home-page .easy-access .easy-access-slider .slide-content h3 {
  color: #3571d6;
  font-weight: 600;
  font-size: 28px;
  line-height: 130%;
}
.home-page .easy-access .easy-access-slider .slide-content p {
  font-size: 16px;
  line-height: 150%;
}
.home-page .core-benefits {
  padding: 80px;
}
.home-page .core-benefits .core-benefits-title {
  font-size: 40px;
  line-height: 120%;
  color: #3571d6;
  text-align: center;
}
.home-page .core-benefits .core-benefits-grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-top: 46px;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item {
  position: relative;
  height: 286px;
  padding: 112px 36px 36px 36px;
  border: 1px solid #eceef1;
  border-radius: 10px;
  background: radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.15) 100%);
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item.core-benefits-item-tall {
  grid-row: span 2;
  height: 490px;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item.core-benefits-item-wide {
  grid-column: span 2;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .corner-image-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .corner-image-wrapper svg {
  position: absolute;
  top: 42px;
  right: 42px;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .core-benefits-item-screenshot-img {
  margin-top: 28px;
  border: 1px solid #fff;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  width: 100%;
  height: 208px;
  background-size: cover;
  position: relative;
  z-index: 2;
  object-fit: cover;
  border-radius: 4px;
  object-position: top;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .core-benefits-item-screenshot-img.core-benefits-log-screenshot {
  object-position: 0 -105px;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .core-benefits-item-content {
  position: relative;
  min-height: 108px;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .core-benefits-item-content .core-benefits-item-title {
  color: #040e46;
  font-size: 26px;
  font-weight: 600;
  line-height: 130%;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item .core-benefits-item-content .core-benefits-item-subtitle {
  margin-top: 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
}
.home-page .core-benefits .core-benefits-grid-container .core-benefits-item:nth-child(3) .core-benefits-item-screenshot-img {
  height: 157px;
}
.home-page .how-it-works-block {
  padding: 135px 100px 80px 100px;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid #eceef1;
  color: #040e46;
}
.home-page .how-it-works-block::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.35;
  z-index: 0;
  border-radius: 20px;
  mix-blend-mode: luminosity;
}
.home-page .how-it-works-block .how-it-works-title {
  color: #000;
  font-size: 40px;
  text-align: center;
}
.home-page .how-it-works-block .how-it-works-slider {
  margin-top: 80px;
}
.home-page .how-it-works-block .how-it-works-slider .swiper {
  padding-bottom: 3rem;
}
.home-page .how-it-works-block .how-it-works-slider .swiper .swiper-button-next,
.home-page .how-it-works-block .how-it-works-slider .swiper .swiper-button-prev {
  display: none;
}
.home-page .how-it-works-block .how-it-works-slider .swiper .swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  opacity: 1;
}
.home-page .how-it-works-block .how-it-works-slider .swiper .swiper-pagination-bullet-active {
  background: #4b6fff;
}
.home-page .how-it-works-block .how-it-works-slider .custom-nav {
  display: flex;
  justify-content: space-between;
}
.home-page .how-it-works-block .how-it-works-slider .custom-nav button {
  position: relative;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  color: #3571d6;
}
.home-page .how-it-works-block .how-it-works-slider .custom-nav button:hover {
  background-color: #f5f5f5;
}
.home-page .how-it-works-block .how-it-works-slider .how-it-works-slide {
  position: relative;
  border-radius: 1rem;
  text-align: center;
  height: 270px;
}
.home-page .how-it-works-block .how-it-works-slider .how-it-works-slide .how-it-works-slide-content {
  background-color: #fff;
  border-radius: 10px;
  height: 240px;
  padding: 80px 28px;
  position: relative;
}
.home-page .how-it-works-block .how-it-works-slider .how-it-works-slide .how-it-works-slide-content .how-it-works-numeration {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  color: #cfe1ff;
  font-weight: 100;
  font-size: 200px;
  line-height: 130%;
}
.home-page .how-it-works-block .how-it-works-slider .how-it-works-slide .icon-wrapper {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 90px;
  width: 90px;
  background-color: #3571d6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-page .how-it-works-block .how-it-works-slider .how-it-works-slide .text {
  font-size: 22px;
  font-weight: 500;
  line-height: 130%;
  z-index: 2;
  position: relative;
}
.home-page .reviews-block {
  display: flex;
  padding: 60px 100px;
  margin-top: 20px;
  background-color: #f9fafb;
  border-radius: 20px;
  border: 1px solid #eceef1;
}
.home-page .reviews-block .review-block-item {
  padding: 6px 40px;
  flex: 1 1;
}
.home-page .reviews-block .review-block-item .quotes-wrapper svg {
  width: 27px;
  height: 21px;
  margin-bottom: 22px;
}
.home-page .reviews-block .review-block-item:nth-child(1) {
  padding-right: 80px;
  border-right: 1px solid #dee1e7;
}
.home-page .reviews-block .review-block-item:nth-child(2) {
  padding-left: 80px;
}
.home-page .reviews-block .review-block-item .review-text-wrapper {
  font-size: 28px;
  font-weight: 400;
  line-height: 130%;
}
.home-page .reviews-block .review-block-item .review-text-wrapper .blue-part {
  color: #3571d6;
}
.home-page .reviews-block .review-block-item .reviewer-wrapper {
  margin-top: 65px;
  display: flex;
  gap: 28px;
}
.home-page .reviews-block .review-block-item .reviewer-wrapper .reviewer-avatar-wrapper img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  object-fit: cover;
}
.home-page .reviews-block .review-block-item .reviewer-wrapper .reviewer-name-wrapper {
  padding: 17px 0;
}
.home-page .reviews-block .review-block-item .reviewer-wrapper .reviewer-name-wrapper .reviewer-name {
  font-size: 24px;
  font-weight: 600;
  line-height: 150%;
}
.home-page .reviews-block .review-block-item .reviewer-wrapper .reviewer-name-wrapper .reviewer-position {
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}
.home-page.isMobile {
  padding-top: 53px;
}
.home-page.isMobile .home-page-content {
  padding: 10px;
}
.home-page.isMobile .home-page-content .home-page-hero {
  margin-top: 17px;
  flex-wrap: wrap;
  flex-direction: column-reverse;
  padding: 20px;
  background-position: center;
}
.home-page.isMobile .home-page-content .home-page-hero .left-block {
  margin-top: 20px;
  padding: 0 !important;
  text-align: center;
}
.home-page.isMobile .home-page-content .home-page-hero .left-block .home-page-hero-title {
  font-weight: 600;
  font-size: 32px;
  line-height: 120%;
}
.home-page.isMobile .home-page-content .home-page-hero .left-block .home-page-hero-subtitle {
  font-weight: 400;
  font-size: 20px;
  line-height: 160%;
}
.home-page.isMobile .home-page-content .home-page-hero .left-block .hero-request-demo-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 28px;
}
.home-page.isMobile .home-page-content .home-page-hero .right-block {
  width: 100%;
  justify-content: center;
  margin-top: 40px;
}
.home-page.isMobile .home-page-content .home-page-hero .right-block img {
  height: 142px;
  width: auto;
  margin: 0 !important;
}
.home-page.isMobile .home-page-content .problem-solution {
  padding: 10px 20px 60px 20px;
  height: unset;
}
.home-page.isMobile .home-page-content .problem-solution .problem-solution-center-block {
  width: 100%;
}
.home-page.isMobile .home-page-content .problem-solution .problem-solution-center-block .problem-solution-arrow-wrapper {
  width: 100%;
}
.home-page.isMobile .home-page-content .problem-solution .problem-solution-center-block .problem-solution-arrow-wrapper img {
  width: 100%;
  height: auto;
}
.home-page.isMobile .home-page-content .problem-solution .problem-solution-center-block .problem-solution-text {
  font-weight: 400;
  font-size: 25px;
  line-height: 180%;
  margin-top: 0;
}
.home-page.isMobile .home-page-content .problem-solution .problem-solution-center-block .how-it-works-btn {
  width: 100%;
  justify-content: center;
}
.home-page.isMobile .home-page-content .staff-education {
  flex-wrap: wrap;
  padding: 20px !important;
  width: 100%;
  height: unset;
  gap: 40px;
}
.home-page.isMobile .home-page-content .staff-education .staff-education-left-block {
  width: 100%;
  min-width: unset;
}
.home-page.isMobile .home-page-content .staff-education .staff-education-left-block img {
  width: 100%;
  height: auto;
  max-height: unset;
}
.home-page.isMobile .home-page-content .staff-education .staff-education-right-block {
  padding-top: 0;
}
.home-page.isMobile .home-page-content .staff-education .staff-education-right-block .staff-education-chip {
  height: 38px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.home-page.isMobile .home-page-content .staff-education .staff-education-right-block .staff-education-subtitle {
  margin-top: 28px;
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
}
.home-page.isMobile .home-page-content .compliance-block {
  flex-wrap: wrap;
  flex-direction: column-reverse;
  padding: 20px 20px 50px 20px !important;
  width: 100%;
  margin-top: 20px;
  gap: 40px;
}
.home-page.isMobile .home-page-content .compliance-block .compliance-left-block {
  width: 100%;
  padding-top: 0;
}
.home-page.isMobile .home-page-content .compliance-block .compliance-left-block .compliance-chip {
  height: 38px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.home-page.isMobile .home-page-content .compliance-block .compliance-left-block .compliance-subtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 160%;
  margin-top: 28px;
}
.home-page.isMobile .home-page-content .compliance-block .compliance-right-block {
  min-width: unset;
  width: 100%;
}
.home-page.isMobile .home-page-content .compliance-block .compliance-right-block img {
  width: 100%;
  height: auto;
  max-height: unset;
}
.home-page.isMobile .home-page-content .operations-block {
  padding: 40px 20px 20px 20px;
  width: 100%;
}
.home-page.isMobile .home-page-content .operations-block .operations-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider {
  margin-top: 36px;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .swiper {
  padding-bottom: 24px;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .swiper .swiper-button-next,
.home-page.isMobile .home-page-content .operations-block .operations-slider .swiper .swiper-button-prev {
  display: none;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .swiper .swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  opacity: 1;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .swiper .swiper-pagination-bullet-active {
  background: #4b6fff;
  border: 1px solid #fff;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .custom-nav {
  display: flex;
  justify-content: space-between;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .custom-nav button {
  position: relative;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  color: #3571d6;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .custom-nav button:hover {
  background-color: #f5f5f5;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide {
  position: relative;
  width: 100%;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide .operation-slide-img-wrapper {
  width: 100%;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide .operation-slide-img-wrapper img {
  height: 240px;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide .operation-slide-img-wrapper:nth-child(1) {
  object-position: left;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide .operation-slide-content {
  margin-top: 24px;
  min-height: 160px;
  color: #fff;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide .operation-slide-content .operation-slide-title {
  font-weight: 600;
  font-size: 28px;
  line-height: 130%;
}
.home-page.isMobile .home-page-content .operations-block .operations-slider .operation-slide .operation-slide-content .operation-slide-subtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
}
.home-page.isMobile .home-page-content .easy-access {
  height: 340px;
  min-height: 340px;
  padding: 160px 20px 20px 20px;
}
.home-page.isMobile .home-page-content .easy-access.bg-0 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.home-page.isMobile .home-page-content .easy-access .easy-access-slider {
  width: 100%;
}
.home-page.isMobile .home-page-content .easy-access .easy-access-slider .slider-container .slider-slide .slide-content {
  padding: 22px 24px 30px 24px;
}
.home-page.isMobile .home-page-content .core-benefits {
  padding: 40px 0;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper {
  margin-top: 32px;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row {
  display: flex;
  gap: 16px;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-cols-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-cols-wrapper .core-benefits-col {
  flex: 1 1;
  width: 100% !important;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col {
  padding: 70px 18px 18px 18px;
  background: radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.15) 100%);
  position: relative;
  border-radius: 10px;
  border: 1px solid #eceef1;
  width: 50%;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .corner-image-wrapper {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .corner-image-wrapper .corner-image {
  width: 100%;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .core-benefits-inner-wrapper {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .core-benefits-inner-wrapper .core-benefits-item-content .core-benefits-item-title {
  color: #040e46;
  font-weight: 600;
  font-size: 18px;
  line-height: 130%;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .core-benefits-inner-wrapper .core-benefits-item-content .core-benefits-item-subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #445169;
  margin-top: 16px;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .core-benefits-inner-wrapper .core-benefits-item-image-wrapper {
  margin-top: auto;
  width: 100%;
  margin-top: 28px;
  display: flex;
  flex-grow: 1;
  align-items: end;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row .core-benefits-col .core-benefits-inner-wrapper .core-benefits-item-image-wrapper img {
  width: 100%;
  object-fit: cover;
  height: auto;
  border: 1px solid #fff;
  border-radius: 4px;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row.core-benefits-row-2 {
  margin-top: 16px;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row.core-benefits-row-3 {
  margin-top: 16px;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row.core-benefits-row-4 {
  margin-top: 16px;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row.core-benefits-row-4 .core-benefits-col {
  width: 100%;
}
.home-page.isMobile .home-page-content .core-benefits .core-benefits-mobile-wrapper .core-benefits-row.core-benefits-row-4 .core-benefits-col .corner-image-wrapper {
  width: 50%;
  margin-left: auto;
  left: unset;
  right: 0;
}
.home-page.isMobile .home-page-content .how-it-works-block {
  padding: 40px 20px;
}
.home-page.isMobile .home-page-content .how-it-works-block .how-it-works-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}
.home-page.isMobile .home-page-content .how-it-works-block .how-it-works-slider {
  margin-top: 60px;
}
.home-page.isMobile .home-page-content .reviews-block {
  flex-wrap: wrap;
  padding: 40px;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item {
  border-right: unset;
  padding: 0;
  flex: 1 1 100%;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item .review-text-wrapper {
  font-weight: 400;
  font-size: 24px;
  line-height: 130%;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item .reviewer-wrapper {
  margin-top: 36px;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item .reviewer-wrapper .reviewer-name-wrapper {
  padding: 0;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item .reviewer-wrapper .reviewer-name-wrapper .reviewer-name {
  font-size: 20px;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item .reviewer-wrapper .reviewer-name-wrapper .reviewer-position {
  margin-top: 2px;
  font-size: 18px;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item:nth-child(1) {
  padding-bottom: 48px;
  border-bottom: 1px solid #dee1e7;
}
.home-page.isMobile .home-page-content .reviews-block .review-block-item:nth-child(2) {
  padding-top: 48px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/styles.scss"],"names":[],"mappings":"AAOA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAZK;EAaL,iBAAA;EACA,iBAAA;AANF;AAQE;EACE,cAjBG;EAkBH,qBAAA;AANJ;AASE;EACE,kBAAA;EACA,mBAAA;AAPJ;AASI;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,yDAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;AAPN;AASM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AAPR;AASQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAPV;AASU;EACE,cAAA;AAPZ;AAWQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AATV;AAYQ;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,4BAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,4DAAA;EACA,6DAAA;AAVV;AAcM;EACE,aAAA;EACA,gBAAA;AAZR;AAcQ;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAZV;AAiBI;EACE,aAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAfN;AAiBM;EACE,UAAA;EACA,iBAAA;AAfR;AAiBQ;EACE,WAAA;EACA,YAAA;AAfV;AAmBM;EACE,YAAA;EACA,kBAAA;AAjBR;AAmBQ;EACE,kBAAA;AAjBV;AAoBQ;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAlBV;AAoBU;EACE,cAAA;AAlBZ;AAsBQ;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AApBV;AAwBM;EACE,UAAA;AAtBR;AAwBQ;EACE,WAAA;EACA,YAAA;EACA,8DAAA;EAEA,+DAAA;AAvBV;AA4BI;EACE,yBAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AA1BN;AA4BM;EACE,gBAAA;EACA,gBAAA;AA1BR;AA4BQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8DAAA;EAEA,+DAAA;AA3BV;AA+BM;EACE,iBAAA;AA7BR;AA+BQ;EACE,yBAAA;EACA,iBAAA;EACA,8DAAA;EACA,+DAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA7BV;AAgCQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA9BV;AAiCQ;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA/BV;AAoCI;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;AAlCN;AAoCM;EACE,gBAAA;EACA,gBAAA;AAlCR;AAoCQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8DAAA;EAEA,+DAAA;AAnCV;AAuCM;EACE,iBAAA;AArCR;AAuCQ;EACE,yBAAA;EACA,iBAAA;EACA,8DAAA;EACA,+DAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AArCV;AAwCQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAtCV;AAyCQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAvCV;AA4CI;EACE,yBAAA;EACA,yDAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AA1CN;AA4CM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA1CR;AA6CM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AA3CR;AA6CQ;EACE,SAAA;EACA,WAAA;AA3CV;AA6CU;EACE,kBAAA;AA3CZ;AA8CU;EACE,kBAAA;AA5CZ;AA+CU;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,4DAAA;EACA,6DAAA;EACA,mBAAA;AA7CZ;AAgDU;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA9CZ;AAgDY;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA9Cd;AAiDY;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/Cd;AAuDE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AArDJ;AAuDI;EACE,yDAAA;EACA,0BAAA;AArDN;AAwDI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cA7VM;AAuSZ;AAyDI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAvDN;AAmFM;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAjFR;AAoFM;EACE,4BAAA;EACA,gBAAA;AAlFR;AAoFQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAlFV;AAqFQ;EACE,eAAA;EACA,iBAAA;AAnFV;AAyFE;EACE,aAAA;AAvFJ;AAyFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAvFN;AA0FI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AAxFN;AA0FM;EACE,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,8GAAA;AAxFR;AA0FQ;EACE,gBAAA;EACA,aAAA;AAxFV;AA2FQ;EACE,mBAAA;AAzFV;AA4FQ;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;AA1FV;AA4FU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA1FZ;AA8FQ;EACE,gBAAA;EACA,sBAAA;EACA,4DAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EAEA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AA7FV;AA+FU;EACE,yBAAA;AA7FZ;AAiGQ;EACE,kBAAA;EACA,iBAAA;AA/FV;AAiGU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/FZ;AAkGU;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAhGZ;AAqGU;EACE,aAAA;AAnGZ;AA0GE;EACE,+BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;AAxGJ;AA0GI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAxGN;AA2GI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAzGN;AA4GI;EACE,gBAAA;AA1GN;AA4GM;EACE,oBAAA;AA1GR;AA4GQ;;EAEE,aAAA;AA1GV;AA6GQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA3GV;AA8GQ;EACE,mBAAA;AA5GV;AAgHM;EACE,aAAA;EACA,8BAAA;AA9GR;AAgHQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBA3jBF;EA4jBE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AA9GV;AA+GU;EACE,yBAAA;AA7GZ;AAkHM;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAhHR;AAkHQ;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAhHV;AAkHU;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAhHZ;AAoHQ;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlHV;AAqHQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;AAnHV;AAyHE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAvHJ;AAyHI;EACE,iBAAA;EACA,SAAA;AAvHN;AA0HQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAxHV;AA4HM;EACE,mBAAA;EACA,+BAAA;AA1HR;AA6HM;EACE,kBAAA;AA3HR;AA8HM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA5HR;AA8HQ;EACE,cAAA;AA5HV;AAgIM;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AA9HR;AAiIU;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA/HZ;AAmIQ;EACE,eAAA;AAjIV;AAmIU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAjIZ;AAoIU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAlIZ;AAyIE;EACE,iBAAA;AAvIJ;AAyII;EACE,aAAA;AAvIN;AAyIM;EACE,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,2BAAA;AAvIR;AAyIQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;AAvIV;AAyIU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAvIZ;AA0IU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAxIZ;AA2IU;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAzIZ;AA6IQ;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;AA3IV;AA6IU;EACE,aAAA;EACA,WAAA;EACA,oBAAA;AA3IZ;AAgJM;EACE,4BAAA;EACA,aAAA;AA9IR;AAgJQ;EACE,WAAA;AA9IV;AAgJU;EACE,WAAA;AA9IZ;AAgJY;EACE,WAAA;EACA,YAAA;AA9Id;AAkJU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAhJZ;AAmJU;EACE,WAAA;EACA,uBAAA;AAjJZ;AAsJM;EACE,eAAA;EACA,wBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AApJR;AAsJQ;EACE,WAAA;EACA,gBAAA;AApJV;AAsJU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AApJZ;AAwJQ;EACE,cAAA;AAtJV;AAwJU;EACE,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AAtJZ;AAyJU;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvJZ;AA4JM;EACE,eAAA;EACA,8BAAA;EACA,uCAAA;EAEA,WAAA;EACA,gBAAA;EACA,SAAA;AA3JR;AA6JQ;EACE,WAAA;EACA,cAAA;AA3JV;AA6JU;EACE,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AA3JZ;AA8JU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA5JZ;AAgKQ;EACE,gBAAA;EACA,WAAA;AA9JV;AAgKU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA9JZ;AAmKM;EACE,4BAAA;EACA,WAAA;AAjKR;AAmKQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjKV;AAoKQ;EACE,gBAAA;AAlKV;AAoKU;EACE,oBAAA;AAlKZ;AAoKY;;EAEE,aAAA;AAlKd;AAqKY;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAnKd;AAsKY;EACE,mBAAA;EACA,sBAAA;AApKd;AAwKU;EACE,aAAA;EACA,8BAAA;AAtKZ;AAwKY;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAh5BN;EAi5BM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAtKd;AAuKc;EACE,yBAAA;AArKhB;AA0KU;EACE,kBAAA;EACA,WAAA;AAxKZ;AA0KY;EACE,WAAA;AAxKd;AA0Kc;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAxKhB;AA2Kc;EACE,qBAAA;AAzKhB;AA6KY;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AA3Kd;AA6Kc;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AA3KhB;AA8Kc;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AA5KhB;AAmLM;EACE,aAAA;EACA,iBAAA;EACA,6BAAA;AAjLR;AAmLQ;EACE,yDAAA;AAjLV;AAoLQ;EACE,WAAA;AAlLV;AAsLc;EACE,4BAAA;AApLhB;AA8LM;EACE,eAAA;AA5LR;AA8LQ;EACE,gBAAA;AA5LV;AA8LU;EACE,aAAA;EACA,SAAA;AA5LZ;AA8LY;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AA5Ld;AA8Lc;EACE,SAAA;EACA,sBAAA;AA5LhB;AAgMY;EACE,4BAAA;EACA,8GAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;AA9Ld;AAgMc;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AA9LhB;AAgMgB;EACE,WAAA;AA9LlB;AAkMc;EACE,aAAA;EACA,YAAA;EACA,sBAAA;AAhMhB;AAmMkB;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAjMpB;AAoMkB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAlMpB;AAsMgB;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AApMlB;AAsMkB;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4DAAA;EACA,6DAAA;AApMpB;AA0MY;EACE,gBAAA;AAxMd;AA2MY;EACE,gBAAA;AAzMd;AA4MY;EACE,gBAAA;AA1Md;AA4Mc;EACE,WAAA;AA1MhB;AA4MgB;EACE,UAAA;EACA,iBAAA;EACA,WAAA;EACA,QAAA;AA1MlB;AAkNM;EACE,kBAAA;AAhNR;AAkNQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAhNV;AAmNQ;EACE,gBAAA;AAjNV;AAqNM;EACE,eAAA;EACA,aAAA;AAnNR;AAqNQ;EACE,mBAAA;EACA,UAAA;EACA,cAAA;AAnNV;AAqNU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAnNZ;AAsNU;EACE,gBAAA;AApNZ;AAsNY;EACE,UAAA;AApNd;AAsNc;EACE,eAAA;AApNhB;AAuNc;EACE,eAAA;EACA,eAAA;AArNhB;AA0NU;EACE,oBAAA;EACA,gCAAA;AAxNZ;AA2NU;EACE,iBAAA;AAzNZ","sourcesContent":["$grey: #445169;\n$blue90: #448aff;\n$blue100: #3571d6;\n$blue-dark: #040e46;\n$white: #fff;\n$blue-border: #3366cc;\n\n.home-page {\n  width: 100%;\n  max-width: 1440px;\n  margin-left: auto;\n  margin-right: auto;\n  color: $grey;\n  line-height: 120%;\n  padding-top: 68px;\n\n  a {\n    color: $grey;\n    text-decoration: none;\n  }\n\n  .home-page-content {\n    padding-left: 20px;\n    padding-right: 20px;\n\n    .home-page-hero {\n      width: 100%;\n      min-height: 570px;\n      background-color: #040e46;\n      background-image: url('../../assets/images/home/hero-bg.png');\n      background-size: cover;\n      border-radius: 20px;\n      margin-top: 22px;\n      padding-bottom: 20px;\n      display: flex;\n      justify-content: space-between;\n\n      .left-block {\n        color: #fff;\n        padding-top: 100px;\n        padding-left: 100px;\n\n        .home-page-hero-title {\n          font-size: 46px;\n          font-weight: 600;\n          line-height: 120%;\n\n          .blue-part {\n            color: #a5c7ff;\n          }\n        }\n\n        .home-page-hero-subtitle {\n          margin-top: 24px;\n          font-size: 22px;\n          font-weight: 400;\n          color: #a5c7ff;\n          line-height: 180%;\n        }\n\n        .hero-request-demo-btn {\n          margin-top: 60px;\n          background-color: #fff;\n          border: none;\n          border-bottom: 2px solid #dee1e7;\n          border-radius: 8px;\n          padding: 12px 24px 12px 24px;\n          gap: 8px;\n          display: flex;\n          align-items: center;\n          width: 200px;\n          height: 46px;\n          color: #448aff;\n          font-weight: 600;\n          box-shadow: 0px 6px 10px -4px #0f17281a;\n          box-shadow: 0px 18px 32px -4px #0f172838;\n        }\n      }\n\n      .right-block {\n        display: flex;\n        align-items: end;\n\n        img {\n          height: 288px;\n          width: auto;\n          margin-right: 50px;\n          margin-bottom: 50px;\n        }\n      }\n    }\n\n    .problem-solution {\n      display: flex;\n      height: 490px;\n      padding-top: 50px;\n      padding-left: 55px;\n      min-height: 490px;\n\n      .paper-wrapper {\n        width: 27%;\n        padding-top: 40px;\n\n        img {\n          width: 100%;\n          height: auto;\n        }\n      }\n\n      .problem-solution-center-block {\n        flex-grow: 1;\n        text-align: center;\n\n        .problem-solution-arrow-wrapper {\n          text-align: center;\n        }\n\n        .problem-solution-text {\n          margin-top: 20px;\n          margin-left: auto;\n          margin-right: auto;\n          font-size: 24px;\n          max-width: 360px;\n          font-weight: 400;\n          line-height: 180%;\n          text-align: center;\n\n          .blue-part {\n            color: #448aff;\n          }\n        }\n\n        .how-it-works-btn {\n          margin-top: 36px;\n          color: #448aff;\n          font-weight: 600;\n          font-size: 16px;\n          border-radius: 8px;\n          border: 2px solid #e7f0ff;\n          padding: 12px 24px 12px 24px;\n          background-color: #fff;\n          display: inline-flex;\n          align-items: center;\n          gap: 8px;\n          margin-left: auto;\n          margin-right: auto;\n        }\n      }\n\n      .problem-solution-right-block {\n        width: 28%;\n\n        img {\n          width: 100%;\n          height: auto;\n          box-shadow: 0px 6px 10px -4px #448aff1a;\n\n          box-shadow: 0px 18px 32px -4px #448aff38;\n        }\n      }\n    }\n\n    .staff-education {\n      background-color: #f9fafb;\n      width: 100%;\n      border: 1px solid rgba(236, 238, 241, 1);\n      border-radius: 20px;\n      padding: 80px 100px;\n      display: flex;\n      gap: 80px;\n\n      .staff-education-left-block {\n        max-width: 470px;\n        min-width: 470px;\n\n        img {\n          width: 100%;\n          height: auto;\n          max-height: 350px;\n          box-shadow: 0px 6px 10px -4px #448aff1a;\n\n          box-shadow: 0px 18px 32px -4px #448aff38;\n        }\n      }\n\n      .staff-education-right-block {\n        padding-top: 60px;\n\n        .staff-education-chip {\n          background-color: #3571d6;\n          padding: 4px 14px;\n          box-shadow: 0px 6px 10px -4px #448aff1a;\n          box-shadow: 0px 18px 32px -4px #448aff38;\n          color: #fff;\n          border-radius: 99px;\n          font-size: 20px;\n          font-weight: 500;\n          display: inline;\n        }\n\n        .staff-education-title {\n          margin-top: 36px;\n          font-size: 40px;\n          font-weight: 400;\n          line-height: 120%;\n        }\n\n        .staff-education-subtitle {\n          margin-top: 36px;\n          font-weight: 400;\n          font-size: 20px;\n          line-height: 180%;\n        }\n      }\n    }\n\n    .compliance-block {\n      width: 100%;\n      padding: 80px 100px;\n      display: flex;\n      gap: 80px;\n      justify-content: space-between;\n\n      .compliance-right-block {\n        max-width: 470px;\n        min-width: 470px;\n\n        img {\n          width: 100%;\n          height: auto;\n          max-height: 320px;\n          box-shadow: 0px 6px 10px -4px #448aff1a;\n\n          box-shadow: 0px 18px 32px -4px #448aff38;\n        }\n      }\n\n      .compliance-left-block {\n        padding-top: 60px;\n\n        .compliance-chip {\n          background-color: #3571d6;\n          padding: 4px 14px;\n          box-shadow: 0px 6px 10px -4px #448aff1a;\n          box-shadow: 0px 18px 32px -4px #448aff38;\n          color: #fff;\n          border-radius: 99px;\n          font-size: 20px;\n          font-weight: 500;\n          display: inline;\n        }\n\n        .compliance-title {\n          margin-top: 36px;\n          font-size: 40px;\n          font-weight: 400;\n          line-height: 120%;\n        }\n\n        .compliance-subtitle {\n          margin-top: 36px;\n          font-size: 20px;\n          line-height: 180%;\n          max-width: 480px;\n        }\n      }\n    }\n\n    .operations-block {\n      background-color: #3571d6;\n      background-image: url('../../assets/images/home/operations-bg.svg');\n      height: 686px;\n      padding: 60px;\n      border-radius: 20px;\n      background-size: cover;\n\n      .operations-title {\n        font-size: 40px;\n        font-weight: 400;\n        color: #fff;\n        text-align: center;\n      }\n\n      .operation-items-wrapper {\n        display: flex;\n        gap: 48px;\n        margin-top: 70px;\n\n        .operation-item {\n          flex: 1;\n          width: 100%;\n\n          &:nth-child(1) {\n            padding-top: 100px;\n          }\n\n          &:nth-child(3) {\n            padding-top: 100px;\n          }\n\n          img {\n            width: 100%;\n            height: 240px;\n            background-size: cover;\n            border: 1px solid #fff;\n            box-shadow: 0px 6px 10px -4px #0f17281a;\n            box-shadow: 0px 18px 32px -4px #0f172838;\n            border-radius: 10px;\n          }\n\n          .operation-item-text-wrapper {\n            padding-left: 14px;\n            padding-right: 14px;\n            margin-top: 24px;\n            color: #fff;\n\n            .operation-item-title {\n              font-size: 28px;\n              line-height: 130%;\n              font-weight: 600;\n            }\n\n            .operation-item-subtitle {\n              margin-top: 12px;\n              font-size: 18px;\n              font-weight: 400;\n              line-height: 150%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .easy-access {\n    padding: 185px 80px;\n    min-height: 520px;\n    margin-top: 20px;\n    border: 1px solid #98a2b3;\n    border-radius: 20px;\n    background-size: cover;\n\n    &.bg-0 {\n      background-image: url(../../assets//images/home/home-slider-bg-1.jpg);\n      background-position: right;\n    }\n\n    .section-title {\n      font-size: 32px;\n      font-weight: 600;\n      margin-bottom: 40px;\n      text-align: center;\n      color: $blue-dark;\n    }\n\n    .easy-access-slider {\n      position: relative;\n      width: 500px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-left: auto;\n\n      // .slider-nav-wrapper {\n      //   display: flex;\n      //   justify-content: space-between;\n      //   width: 100%;\n      //   margin-top: 24px;\n      // }\n\n      // .slider-nav {\n      //   z-index: 10;\n      //   width: 48px;\n      //   height: 48px;\n      //   border-radius: 50%;\n      //   background-color: $white;\n      //   display: flex;\n      //   align-items: center;\n      //   justify-content: center;\n      //   border: none;\n      //   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n      //   cursor: pointer;\n      //   transition: all 0.2s;\n      //   color: #3571d6;\n      //   &:hover {\n      //     background-color: #f5f5f5;\n      //   }\n      // }\n\n      .slider-container {\n        width: 100%;\n        overflow: hidden;\n        border-radius: 16px;\n        background-color: #fff;\n      }\n\n      .slide-content {\n        padding: 38px 46px 46px 46px;\n        text-align: left;\n\n        h3 {\n          color: #3571d6;\n          font-weight: 600;\n          font-size: 28px;\n          line-height: 130%;\n        }\n\n        p {\n          font-size: 16px;\n          line-height: 150%;\n        }\n      }\n    }\n  }\n\n  .core-benefits {\n    padding: 80px;\n\n    .core-benefits-title {\n      font-size: 40px;\n      line-height: 120%;\n      color: #3571d6;\n      text-align: center;\n    }\n\n    .core-benefits-grid-container {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 32px;\n      margin-top: 46px;\n\n      .core-benefits-item {\n        position: relative;\n        height: 286px;\n        padding: 112px 36px 36px 36px;\n        border: 1px solid #eceef1;\n        border-radius: 10px;\n        background: radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.15) 100%);\n\n        &.core-benefits-item-tall {\n          grid-row: span 2;\n          height: 490px;\n        }\n\n        &.core-benefits-item-wide {\n          grid-column: span 2;\n        }\n\n        .corner-image-wrapper {\n          position: absolute;\n          right: 0;\n          top: 0;\n          text-align: right;\n\n          svg {\n            position: absolute;\n            top: 42px;\n            right: 42px;\n          }\n        }\n\n        .core-benefits-item-screenshot-img {\n          margin-top: 28px;\n          border: 1px solid #fff;\n          box-shadow: 0px 6px 10px -4px #0f17281a;\n          box-shadow: 0px 18px 32px -4px #0f172838;\n          width: 100%;\n          height: 208px;\n\n          background-size: cover;\n          position: relative;\n          z-index: 2;\n          object-fit: cover;\n          border-radius: 4px;\n          object-position: top;\n\n          &.core-benefits-log-screenshot {\n            object-position: 0 -105px;\n          }\n        }\n\n        .core-benefits-item-content {\n          position: relative;\n          min-height: 108px;\n\n          .core-benefits-item-title {\n            color: #040e46;\n            font-size: 26px;\n            font-weight: 600;\n            line-height: 130%;\n          }\n\n          .core-benefits-item-subtitle {\n            margin-top: 12px;\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 150%;\n          }\n        }\n\n        &:nth-child(3) {\n          .core-benefits-item-screenshot-img {\n            height: 157px;\n          }\n        }\n      }\n    }\n  }\n\n  .how-it-works-block {\n    padding: 135px 100px 80px 100px;\n    width: 100%;\n    border-radius: 20px;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n    border: 1px solid #eceef1;\n    color: #040e46;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-image: url('../../assets/images/home/hero-bg.png');\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: center;\n      opacity: 0.35;\n      z-index: 0;\n      border-radius: 20px;\n      mix-blend-mode: luminosity;\n    }\n\n    .how-it-works-title {\n      color: #000;\n      font-size: 40px;\n      text-align: center;\n    }\n\n    .how-it-works-slider {\n      margin-top: 80px;\n\n      .swiper {\n        padding-bottom: 3rem;\n\n        .swiper-button-next,\n        .swiper-button-prev {\n          display: none;\n        }\n\n        .swiper-pagination-bullet {\n          background: #fff;\n          width: 10px;\n          height: 10px;\n          opacity: 1;\n        }\n\n        .swiper-pagination-bullet-active {\n          background: #4b6fff;\n        }\n      }\n\n      .custom-nav {\n        display: flex;\n        justify-content: space-between;\n\n        button {\n          position: relative;\n          z-index: 10;\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          background-color: $white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border: none;\n          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n          cursor: pointer;\n          transition: all 0.2s;\n          color: #3571d6;\n          &:hover {\n            background-color: #f5f5f5;\n          }\n        }\n      }\n\n      .how-it-works-slide {\n        position: relative;\n        border-radius: 1rem;\n        text-align: center;\n        height: 270px;\n\n        .how-it-works-slide-content {\n          background-color: #fff;\n          border-radius: 10px;\n          height: 240px;\n          padding: 80px 28px;\n          position: relative;\n\n          .how-it-works-numeration {\n            position: absolute;\n            top: 50%;\n            left: 0;\n            transform: translate(0, -50%);\n            color: #cfe1ff;\n            font-weight: 100;\n            font-size: 200px;\n            line-height: 130%;\n          }\n        }\n\n        .icon-wrapper {\n          position: absolute;\n          z-index: 2;\n          top: 0;\n          left: 50%;\n          transform: translate(-50%, 0);\n          height: 90px;\n          width: 90px;\n          background-color: #3571d6;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n\n        .text {\n          font-size: 22px;\n          font-weight: 500;\n          line-height: 130%;\n          z-index: 2;\n          position: relative;\n        }\n      }\n    }\n  }\n\n  .reviews-block {\n    display: flex;\n    padding: 60px 100px;\n    margin-top: 20px;\n    background-color: #f9fafb;\n    border-radius: 20px;\n    border: 1px solid #eceef1;\n\n    .review-block-item {\n      padding: 6px 40px;\n      flex: 1;\n\n      .quotes-wrapper {\n        svg {\n          width: 27px;\n          height: 21px;\n          margin-bottom: 22px;\n        }\n      }\n\n      &:nth-child(1) {\n        padding-right: 80px;\n        border-right: 1px solid #dee1e7;\n      }\n\n      &:nth-child(2) {\n        padding-left: 80px;\n      }\n\n      .review-text-wrapper {\n        font-size: 28px;\n        font-weight: 400;\n        line-height: 130%;\n\n        .blue-part {\n          color: #3571d6;\n        }\n      }\n\n      .reviewer-wrapper {\n        margin-top: 65px;\n        display: flex;\n        gap: 28px;\n\n        .reviewer-avatar-wrapper {\n          img {\n            height: 100px;\n            width: 100px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n        }\n\n        .reviewer-name-wrapper {\n          padding: 17px 0;\n\n          .reviewer-name {\n            font-size: 24px;\n            font-weight: 600;\n            line-height: 150%;\n          }\n\n          .reviewer-position {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 150%;\n          }\n        }\n      }\n    }\n  }\n\n  &.isMobile {\n    padding-top: 53px;\n\n    .home-page-content {\n      padding: 10px;\n\n      .home-page-hero {\n        margin-top: 17px;\n        flex-wrap: wrap;\n        flex-direction: column-reverse;\n        padding: 20px;\n        background-position: center;\n\n        .left-block {\n          margin-top: 20px;\n          padding: 0 !important;\n          text-align: center;\n\n          .home-page-hero-title {\n            font-weight: 600;\n            font-size: 32px;\n            line-height: 120%;\n          }\n\n          .home-page-hero-subtitle {\n            font-weight: 400;\n            font-size: 20px;\n            line-height: 160%;\n          }\n\n          .hero-request-demo-btn {\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            margin-top: 28px;\n          }\n        }\n\n        .right-block {\n          width: 100%;\n          justify-content: center;\n          margin-top: 40px;\n\n          img {\n            height: 142px;\n            width: auto;\n            margin: 0 !important;\n          }\n        }\n      }\n\n      .problem-solution {\n        padding: 10px 20px 60px 20px;\n        height: unset;\n\n        .problem-solution-center-block {\n          width: 100%;\n\n          .problem-solution-arrow-wrapper {\n            width: 100%;\n\n            img {\n              width: 100%;\n              height: auto;\n            }\n          }\n\n          .problem-solution-text {\n            font-weight: 400;\n            font-size: 25px;\n            line-height: 180%;\n            margin-top: 0;\n          }\n\n          .how-it-works-btn {\n            width: 100%;\n            justify-content: center;\n          }\n        }\n      }\n\n      .staff-education {\n        flex-wrap: wrap;\n        padding: 20px !important;\n        width: 100%;\n        height: unset;\n        gap: 40px;\n\n        .staff-education-left-block {\n          width: 100%;\n          min-width: unset;\n\n          img {\n            width: 100%;\n            height: auto;\n            max-height: unset;\n          }\n        }\n\n        .staff-education-right-block {\n          padding-top: 0;\n\n          .staff-education-chip {\n            height: 38px;\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n          }\n\n          .staff-education-subtitle {\n            margin-top: 28px;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 180%;\n          }\n        }\n      }\n\n      .compliance-block {\n        flex-wrap: wrap;\n        flex-direction: column-reverse;\n        padding: 20px 20px 50px 20px !important;\n\n        width: 100%;\n        margin-top: 20px;\n        gap: 40px;\n\n        .compliance-left-block {\n          width: 100%;\n          padding-top: 0;\n\n          .compliance-chip {\n            height: 38px;\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n          }\n\n          .compliance-subtitle {\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 160%;\n            margin-top: 28px;\n          }\n        }\n\n        .compliance-right-block {\n          min-width: unset;\n          width: 100%;\n\n          img {\n            width: 100%;\n            height: auto;\n            max-height: unset;\n          }\n        }\n      }\n\n      .operations-block {\n        padding: 40px 20px 20px 20px;\n        width: 100%;\n\n        .operations-title {\n          font-weight: 400;\n          font-size: 32px;\n          line-height: 120%;\n          text-align: center;\n        }\n\n        .operations-slider {\n          margin-top: 36px;\n\n          .swiper {\n            padding-bottom: 24px;\n\n            .swiper-button-next,\n            .swiper-button-prev {\n              display: none;\n            }\n\n            .swiper-pagination-bullet {\n              background: #fff;\n              width: 10px;\n              height: 10px;\n              opacity: 1;\n            }\n\n            .swiper-pagination-bullet-active {\n              background: #4b6fff;\n              border: 1px solid #fff;\n            }\n          }\n\n          .custom-nav {\n            display: flex;\n            justify-content: space-between;\n\n            button {\n              position: relative;\n              z-index: 10;\n              width: 48px;\n              height: 48px;\n              border-radius: 50%;\n              background-color: $white;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border: none;\n              box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n              cursor: pointer;\n              transition: all 0.2s;\n              color: #3571d6;\n              &:hover {\n                background-color: #f5f5f5;\n              }\n            }\n          }\n\n          .operation-slide {\n            position: relative;\n            width: 100%;\n\n            .operation-slide-img-wrapper {\n              width: 100%;\n\n              img {\n                height: 240px;\n                width: 100%;\n                object-fit: cover;\n                border-radius: 10px;\n              }\n\n              &:nth-child(1) {\n                object-position: left;\n              }\n            }\n\n            .operation-slide-content {\n              margin-top: 24px;\n              min-height: 160px;\n              color: #fff;\n\n              .operation-slide-title {\n                font-weight: 600;\n                font-size: 28px;\n                line-height: 130%;\n              }\n\n              .operation-slide-subtitle {\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 150%;\n              }\n            }\n          }\n        }\n      }\n\n      .easy-access {\n        height: 340px;\n        min-height: 340px;\n        padding: 160px 20px 20px 20px;\n\n        &.bg-0 {\n          background-image: url('../../assets/images/home/home-slider-mobile-bg-1.png');\n        }\n\n        .easy-access-slider {\n          width: 100%;\n\n          .slider-container {\n            .slider-slide {\n              .slide-content {\n                padding: 22px 24px 30px 24px;\n\n                h3 {\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .core-benefits {\n        padding: 40px 0;\n\n        .core-benefits-mobile-wrapper {\n          margin-top: 32px;\n\n          .core-benefits-row {\n            display: flex;\n            gap: 16px;\n\n            .core-benefits-cols-wrapper {\n              display: flex;\n              flex-direction: column;\n              gap: 16px;\n              width: 50%;\n\n              .core-benefits-col {\n                flex: 1;\n                width: 100% !important;\n              }\n            }\n\n            .core-benefits-col {\n              padding: 70px 18px 18px 18px;\n              background: radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.15) 100%);\n              position: relative;\n              border-radius: 10px;\n              border: 1px solid #eceef1;\n              width: 50%;\n\n              .corner-image-wrapper {\n                width: 100%;\n                position: absolute;\n                top: 0;\n                left: 0;\n\n                .corner-image {\n                  width: 100%;\n                }\n              }\n\n              .core-benefits-inner-wrapper {\n                display: flex;\n                height: 100%;\n                flex-direction: column;\n\n                .core-benefits-item-content {\n                  .core-benefits-item-title {\n                    color: #040e46;\n                    font-weight: 600;\n                    font-size: 18px;\n                    line-height: 130%;\n                  }\n\n                  .core-benefits-item-subtitle {\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 150%;\n                    color: #445169;\n                    margin-top: 16px;\n                  }\n                }\n\n                .core-benefits-item-image-wrapper {\n                  margin-top: auto;\n                  width: 100%;\n                  margin-top: 28px;\n                  display: flex;\n                  flex-grow: 1;\n                  align-items: end;\n\n                  img {\n                    width: 100%;\n                    object-fit: cover;\n                    height: auto;\n                    border: 1px solid #fff;\n                    border-radius: 4px;\n                    box-shadow: 0px 6px 10px -4px #0f17281a;\n                    box-shadow: 0px 18px 32px -4px #0f172838;\n                  }\n                }\n              }\n            }\n\n            &.core-benefits-row-2 {\n              margin-top: 16px;\n            }\n\n            &.core-benefits-row-3 {\n              margin-top: 16px;\n            }\n\n            &.core-benefits-row-4 {\n              margin-top: 16px;\n\n              .core-benefits-col {\n                width: 100%;\n\n                .corner-image-wrapper {\n                  width: 50%;\n                  margin-left: auto;\n                  left: unset;\n                  right: 0;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .how-it-works-block {\n        padding: 40px 20px;\n\n        .how-it-works-title {\n          font-weight: 400;\n          font-size: 32px;\n          line-height: 120%;\n          text-align: center;\n        }\n\n        .how-it-works-slider {\n          margin-top: 60px;\n        }\n      }\n\n      .reviews-block {\n        flex-wrap: wrap;\n        padding: 40px;\n\n        .review-block-item {\n          border-right: unset;\n          padding: 0;\n          flex: 1 1 100%;\n\n          .review-text-wrapper {\n            font-weight: 400;\n            font-size: 24px;\n            line-height: 130%;\n          }\n\n          .reviewer-wrapper {\n            margin-top: 36px;\n\n            .reviewer-name-wrapper {\n              padding: 0;\n\n              .reviewer-name {\n                font-size: 20px;\n              }\n\n              .reviewer-position {\n                margin-top: 2px;\n                font-size: 18px;\n              }\n            }\n          }\n\n          &:nth-child(1) {\n            padding-bottom: 48px;\n            border-bottom: 1px solid #dee1e7;\n          }\n\n          &:nth-child(2) {\n            padding-top: 48px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
